import AddIcon from "@mui/icons-material/Add";
import { Box, Typography } from "@mui/material";
import CustomToolTipWithPermission from "../../../../../components/CustomToolTipWithPermission";
import ContainedButton from "../../../../../components/buttons/ContainedButton";

export default function AddNewAssetButton({
  onClick,
  isLoading,
  hasPermission,
}) {
  return (
    <Box
      sx={{
        padding: "10px",
      }}
    >
      <ContainedButton
        onClick={hasPermission ? onClick : null}
        color="primary"
        size="medium"
        loading={isLoading}
        sxProps={{
          width: "150px",
          cursor: hasPermission ? "pointer" : "default",
        }}
      >
        <CustomToolTipWithPermission
          title={null}
          permission={hasPermission}
          placement="top"
        >
          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: 1,
            }}
          >
            <AddIcon fontSize="small" />
            <Typography variant="overline">Add New Asset</Typography>
          </Box>
        </CustomToolTipWithPermission>
      </ContainedButton>{" "}
    </Box>
  );
}
